import { BaseApiRouteService } from "mrb/core";

class LoadioDeviceContentProfileApiRouteService extends BaseApiRouteService {
    constructor() {
        super("loadio/devices");
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery,page,rpp,sort,fields}`, filter);
    }

    assignProfile(deviceId) {
        return `${this.base}/${deviceId}/content-profile`;
    }

    batchAssignProfile() {
        return `${this.base}/content-profile`;
    }
}

export default LoadioDeviceContentProfileApiRouteService;
